"use client";

import dynamic from "next/dynamic";

/**
 * Defers {@link PlatformCursors} (smooth cursor + ClickSpark) off the marketing
 * critical path. SaaS shell keeps sync mount via ClientProviders if needed.
 */
export const MarketingPlatformCursors = dynamic(
	() =>
		import("@shared/components/custom-cursor/platform-cursors").then(
			(m) => m.PlatformCursors,
		),
	{ ssr: false },
);
